import api from '../../api';
import models from '../../../models';
import output from '../../../utils/output-writer';
import { WrappedRegisterToolFuncType } from '../tool-definition';
import { createCallToolResult, createTextContent } from '../output-parser';

const inputSchema = models.tool.getTuningCasesInput;

export function setup(register: WrappedRegisterToolFuncType) {
  register(
    'get-tuning-cases',
    {
      title: 'Get Tuning Cases',
      description: `Fetch the known alert cases for monitors, including any ground truth expectations already recorded. 

      Use this tool when authoring or testing a book to discover which cases already have ground truth expectations — so you can test against them instead of asking the user for every expectation from scratch.

      Each case in the response may have:
      - truths: ground truth expectations (the "expected outcome" for this case)
      - alertLink: link to the original alert.`,
      inputSchema,
    },
    async (input) => {
      output.info('Fetching tuning cases');

      const { from, to, limit, monitors } = input;
      const result = await api.getTuningCases({
        query: { from, to, limit, monitors },
      });

      return createCallToolResult({
        contentBlocks: [createTextContent(JSON.stringify(result, null, 2))],
      });
    }
  );
}

export default { setup };
